import { UserX } from "lucide-react";

/**
 * Página exibida para usuários com role "user" (sem acesso ao sistema).
 */
export default function UserNoAccess() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 text-center px-4 bg-gray-50">
      <div className="bg-red-100 rounded-full p-6">
        <UserX className="w-12 h-12 text-red-500" />
      </div>
      <h1 className="text-2xl font-bold text-gray-800">Acesso Pendente</h1>
      <p className="text-gray-500 max-w-md">
        Sua conta ainda não foi ativada. Solicite ao administrador do sistema que configure seu nível de acesso.
      </p>
      <div className="bg-white rounded-lg border border-gray-200 p-4 max-w-sm w-full mt-2">
        <p className="text-sm text-gray-600 font-medium">Entre em contato com:</p>
        <p className="text-sm text-gray-500 mt-1">Administrador do Box Warehouse</p>
      </div>
    </div>
  );
}
